
<div class="modal-dialog" style="max-width: 600px;">
  <div class="modal-content">
    <form #siteForm="ngForm">
      <div class="modal-header">
        <h4 class="modal-title">Add/Modify CDF</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <div class="row">
          <div class="form-group col">
            <div class="form-check">
              <input class="form-check-input" type="radio" name="system" [(ngModel)]="system" autoLinkToLabel value="portico" (change)="clearBuildings()">
              <label class="form-check-label">Get CDF from Portico</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="system" [(ngModel)]="system" autoLinkToLabel value="sold" (change)="clearBuildings()">
              <label class="form-check-label">Get CDF from SOLD</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col">
            <label class="required" for="id">CDF ID</label>
            <div class="input-group mb-3">
              <input class="form-control" id="id" type="text" [(ngModel)]="id" name="id" maxlength="100" required (change)="clearBuildings()">
              <div class="input-group-append">
                <button class="btn btn-outline-primary" type="button" (click)="loadCdfDetails()">Lookup</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col" *ngIf="selectableBuildings?.length">
            <p>OPTIONAL: Limit CDF import to specific buildings (skip to import all)</p>
            <div class="col-12" *ngIf="selectableBuildings.length &gt; 10">
              <div class="col-4 d-inline-block" style="top: -32px">
                <ng-multiselect-dropdown [placeholder]="'Site'" [settings]="dropdownSiteSettings" [data]="siteList" (onSelect)="onSiteSelect($event)" (onSelectAll)="onSelectAllSites($event)" (onDeSelect)="onSiteDeselect($event)" (onDeSelectAll)="onDeselectAllSite()"></ng-multiselect-dropdown>
              </div>
              <div class="col-4 d-inline-block">
                <ng-multiselect-dropdown class="col-4" [placeholder]="'Building'" [settings]="dropdownBuildingSettings" [data]="buildingList" (onSelect)="onBuildingSelect($event)" (onSelectAll)="onSelectAllBuildings($event)" (onDeSelect)="onBuildingDeselect($event)" (onDeSelectAll)="onDeselectAllBuilding()"></ng-multiselect-dropdown>
              </div>
              <div class="col-4 d-inline-block">
                <ng-multiselect-dropdown class="col-4" [placeholder]="'Floor'" [settings]="dropdownFloorSettings" [data]="floorList" (onSelect)="onFloorSelect($event)" (onSelectAll)="onSelectAllFloors($event)" (onDeSelect)="onFloorDeselect($event)" (onDeSelectAll)="onDeselectAllFloor()"></ng-multiselect-dropdown>
              </div>
            </div>
            <div class="col-12" style="overflow: auto; max-height: 200px;">
              <div class="form-check" *ngFor="let building of showBuildings; let i = index">
                <input class="form-check-input" type="checkbox" [name]="&quot;building&quot; + i" [(ngModel)]="building.selected" autoLinkToLabel>
                <label class="form-check-label">{{ building.site || "(empty)" }}-{{ building.building || "(empty)" }}-{{ building.floor || "(empty)" }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-danger" type="button" (click)="remove()" [disabled]="!canRemove">Remove</button>
        <button class="btn btn-primary" type="button" (click)="save()" [disabled]="!canSave">Save</button>
        <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
</div>